/**
 * MetricCard Component
 * Sprint 20: Frontend Adaptativo - Fase 4 del Plan Maestro
 * Tarjeta de métrica con estilo colorido como el mockup
 */

import { LucideIcon } from "lucide-react";

interface MetricCardProps {
    title: string;
    value: number | string;
    icon: LucideIcon;
    variant?: 'primary' | 'blue' | 'gold' | 'gray';
    subtitle?: string;
}

export function MetricCard({
    title,
    value,
    icon: Icon,
    variant = 'primary',
    subtitle
}: MetricCardProps) {

    // Estilos según variante - Coloridos como el mockup
    const variantStyles = {
        primary: {
            bg: 'bg-gradient-to-br from-[#0f2744] to-[#1e3a5f]',
            iconBg: 'bg-white/20',
            iconColor: 'text-white',
            titleColor: 'text-white/80',
            valueColor: 'text-white',
            subtitleColor: 'text-white/60'
        },
        blue: {
            bg: 'bg-gradient-to-br from-[#1e3a5f] to-[#3d5a80]',
            iconBg: 'bg-white/20',
            iconColor: 'text-white',
            titleColor: 'text-white/80',
            valueColor: 'text-white',
            subtitleColor: 'text-white/60'
        },
        gold: {
            bg: 'bg-gradient-to-br from-[#c9a227] to-[#e8d17a]',
            iconBg: 'bg-white/30',
            iconColor: 'text-white',
            titleColor: 'text-white/90',
            valueColor: 'text-white',
            subtitleColor: 'text-white/70'
        },
        gray: {
            bg: 'bg-white border border-gray-200',
            iconBg: 'bg-gray-100',
            iconColor: 'text-gray-500',
            titleColor: 'text-gray-500',
            valueColor: 'text-gray-800',
            subtitleColor: 'text-gray-400'
        }
    };

    const styles = variantStyles[variant];

    return (
        <div className={`relative overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-shadow duration-200 ${styles.bg}`}>
            <div className="p-5">
                <div className="flex items-start justify-between">
                    <div className="flex-1">
                        <p className={`text-sm font-medium uppercase tracking-wide ${styles.titleColor}`}>
                            {title}
                        </p>
                        <p className={`text-4xl font-bold mt-2 ${styles.valueColor}`}>
                            {value}
                        </p>
                        {subtitle && (
                            <p className={`text-xs mt-1 ${styles.subtitleColor}`}>{subtitle}</p>
                        )}
                    </div>
                    <div className={`p-3 rounded-xl ${styles.iconBg}`}>
                        <Icon className={`h-6 w-6 ${styles.iconColor}`} />
                    </div>
                </div>
            </div>
        </div>
    );
}
